import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ShareAuthCheckData } from '../../types';
import { ShareIdApi } from '../../apis/share-id-api';
import type { ShareIdRepository } from '../../services/share-tools-repository';

@injectable()
export class ShareIdRepositoryImpl implements ShareIdRepository {
    constructor(
        @inject(ShareIdApi) private shareIdApi: ShareIdApi
    ) {
    }

    getShareIdForGuest(data: ShareAuthCheckData) {
        return this.shareIdApi.getShareIdForGuest(data);
    }

    getShareId(data: ShareAuthCheckData) {
        return this.shareIdApi.getShareId(data);
    }

    getPDAShareId(data: Parameters<ShareIdRepository['getPDAShareId']>[0]) {
        return this.shareIdApi.getPDAShareId(data);
    }

    getLcaShareId(data: Parameters<ShareIdRepository['getLcaShareId']>[0]) {
        return this.shareIdApi.getLcaShareId(data);
    }

    convertLcaShare(jobId: string) {
        return this.shareIdApi.convertLcaShare(jobId);
    }

    sendPDAShareByEmail(data: Parameters<ShareIdRepository['sendPDAShareByEmail']>[0]) {
        return this.shareIdApi.sendPDAShareByEmail(data);
    }
}
